import EditIcon from "@mui/icons-material/Edit";
import { Box, Button, IconButton, Stack, Tooltip, Typography } from "@mui/material";

const columns = [
  { key: "name", label: "Nombre", width: "minmax(250px, 2.2fr)" },
  { key: "sector", label: "Sector", width: "minmax(130px, 1fr)" },
  { key: "detail", label: "Detalle", width: "minmax(130px, 1fr)" },
  { key: "status", label: "Estado", width: "minmax(110px, 0.85fr)" },
  { key: "actions", label: "Acciones", width: "minmax(90px, 0.7fr)" },
];

const gridSx = {
  display: "grid",
  gridTemplateColumns: columns.map((column) => column.width).join(" "),
  columnGap: 1,
  alignItems: "center",
  "& > *": { minWidth: 0 },
};

function TextCell({ children }) {
  return (
    <Typography
      noWrap
      title={typeof children === "string" ? children : undefined}
      sx={{
        color: "primary.900",
        fontSize: 14,
        fontWeight: 600,
        textAlign: "center",
      }}
    >
      {children}
    </Typography>
  );
}

function StatusPill({ active }) {
  return (
    <Box
      sx={{
        width: 78,
        px: 0.8,
        py: 0.55,
        borderRadius: "20px",
        bgcolor: active ? "rgba(33, 150, 83, 0.16)" : "rgba(195, 60, 60, 0.16)",
        boxShadow: "inset 0px 0px 3px rgba(142, 142, 159, 0.28)",
      }}
    >
      <Typography
        sx={{
          color: active ? "rgba(18, 111, 63, 1)" : "rgba(160, 49, 49, 1)",
          fontSize: 12,
          fontWeight: 800,
          textAlign: "center",
        }}
      >
        {active ? "Activo" : "Inactivo"}
      </Typography>
    </Box>
  );
}

export default function RecetasTable({
  rows = [],
  loading = false,
  onViewRecipe,
  onEdit,
  emptyMessage = "Todavía no hay recetas cargadas.",
}) {
  return (
    <Box
      sx={{
        flex: 1,
        minHeight: 0,
        borderRadius: "20px",
        overflow: "hidden",
      }}
    >
      <Box sx={{ height: "100%", overflowX: "auto", overflowY: "hidden" }}>
        <Box
          sx={{
            minWidth: 760,
            height: "100%",
            bgcolor: "neutral.50",
            overflowY: "auto",
          }}
        >
          <Box
            sx={{
              ...gridSx,
              position: "sticky",
              top: 0,
              zIndex: 1,
              bgcolor: "neutral.600",
              px: 2,
              py: 1.6,
            }}
          >
            {columns.map((column) => (
              <Typography
                key={column.key}
                sx={{
                  fontSize: 14,
                  fontWeight: 700,
                  color: "logoblanco",
                  lineHeight: 1.15,
                  textAlign: "center",
                }}
              >
                {column.label}
              </Typography>
            ))}
          </Box>

          <Box
            sx={{
              bgcolor: "neutral.50",
            }}
          >
            {rows.map((recipe) => (
              <Box
                key={recipe.id}
                sx={{
                  px: 2,
                  py: 1.2,
                  minHeight: 58,
                  borderBottom: "1px solid rgba(0,0,0,.06)",
                  "&:hover": { bgcolor: "rgba(0,0,0,.03)" },
                }}
              >
                <Box sx={gridSx}>
                  <TextCell>{recipe.name}</TextCell>
                  <TextCell>{recipe.sectorLabel}</TextCell>

                  <Box sx={{ display: "flex", justifyContent: "center" }}>
                    <Button
                      type="button"
                      size="small"
                      disabled={loading}
                      onClick={() => onViewRecipe?.(recipe)}
                      sx={{
                        width: 88,
                        minWidth: 88,
                        py: 0.55,
                        px: 0.8,
                        borderRadius: "20px",
                        bgcolor: "secondary.500",
                        color: "logoblanco",
                        textTransform: "none",
                        boxShadow: "inset 0px 0px 3px rgba(142, 142, 159, 0.35)",
                        "&:hover": { bgcolor: "secondary.600" },
                      }}
                    >
                      <Typography sx={{ fontSize: 12, fontWeight: 800 }}>
                        Ver más
                      </Typography>
                    </Button>
                  </Box>

                  <Box sx={{ display: "flex", justifyContent: "center" }}>
                    <StatusPill active={recipe.isActive} />
                  </Box>

                  <Stack direction="row" sx={{ justifyContent: "center" }}>
                    <Tooltip title="Editar" arrow>
                      <span>
                        <IconButton
                          size="small"
                          disabled={loading}
                          aria-label={`Editar ${recipe.name}`}
                          onClick={() => onEdit?.(recipe)}
                          sx={{
                            width: 32,
                            height: 32,
                            bgcolor: "neutral.50",
                            boxShadow: "0px 2px 8px rgba(0,0,0,.08)",
                            "&:hover": { bgcolor: "secondary.100" },
                          }}
                        >
                          <EditIcon sx={{ fontSize: 18, color: "primary.900" }} />
                        </IconButton>
                      </span>
                    </Tooltip>
                  </Stack>
                </Box>
              </Box>
            ))}

            {rows.length === 0 && (
              <Box sx={{ p: 3 }}>
                <Typography sx={{ color: "neutral.700", fontWeight: 600 }}>
                  {loading ? "Cargando recetas..." : emptyMessage}
                </Typography>
              </Box>
            )}
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
